import {
    ExportReport,
} from '@/api/operate'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {resetRouter} from '@/router'



// 用户记录
const state = {
    
};

const mutations = {    
    
}

const actions = {
    async ExportReport({commit}, {sDate='',eDate=''}) {
        return ExportReport({userId: getToken(),sDate,eDate});
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
